
import { useEffect } from 'react'
import Select from 'react-select'
import { AstricSign } from '../../Helper/AstricSign'

export const HeadingDDL = (props) => {
    const { HeadingDDLID, setHeadingDDLID } = props

    const HeadingDDLData = [
        {
            headingID: '1',
            headingName: 'Road and Footpath'
        },
        {
            headingID: '2',
            headingName: 'Other'
        }
    ]

    useEffect(() => {
        handleProjectDDL()
    }, [])

    const handleProjectDDL = () => {
        if (HeadingDDLData && HeadingDDLData.length > 0) {
            let list = HeadingDDLData.map((item) => ({
                value: item.headingID,
                label: item.headingName,
            }))

            setHeadingDDLID({ ...HeadingDDLID, DDL: list })
        }
        else {
            setHeadingDDLID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Work Type {<AstricSign />} </b></label>
            <Select
                isClearable
                isSearchable
                maxMenuHeight={150}
                value={{ value: HeadingDDLID.ID, label: HeadingDDLID.Label }}
                onChange={(e) => {
                    e ?
                        setHeadingDDLID({ ...HeadingDDLID, ID: e.value, Label: e.label })
                        :
                        setHeadingDDLID({ ...HeadingDDLID, ID: 0, Label: "Select..." })

                }}
                options={HeadingDDLID.DDL}
            />
        </div>
    )
}